export const getTransactionLink = (txId: string) =>
  `https://solscan.io/tx/${txId}`;
